import { Pipe, PipeTransform } from '@angular/core';
import { NotificationService } from '@sharedServices/notification.service';
import imageCompression from 'browser-image-compression'

@Pipe({
  name: 'decodeImage'
})

export class DecodeImagePipe implements PipeTransform {

  constructor(
    private notificationService: NotificationService
  ) {}

  /**
   * transform
   * @param imgBase64List - Array of encoded base64 image(s)
   * @return any[] - Array containing URL of image(s)
   */
  transform(imgBase64List: string[]): Promise<any[]> {
    let promiseArr: any = []

    return new Promise((resolve) => {
      Array.from(imgBase64List).forEach((imgBase64: string) => {
        const promise = new Promise((resolve, reject) => {
          imageCompression.loadImage(imgBase64).then(() => {
            imageCompression.getFilefromDataUrl(imgBase64, 'image_ap').then((image: File) => {
              resolve({imageUrl: URL.createObjectURL(image)})
            })
          }).catch(() => {
            this.notificationService.showError('Unable to decode base64 as string is corrupted/damaged', 'Decoding Error')
            reject('base64 is corrupted/damaged')
          })
        })
        promiseArr.push(promise)
      })
      Promise.all(
        promiseArr.map((promise) =>
          promise.catch(() => null)
        )
      ).then((values: any) => {
        resolve(values.filter(value => value))
      })
    })
  }
}
